<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({ request: { type: Object, required: true } });
const { t } = useI18n();
const conditionFlag = value => {
  if (value === null || value === undefined || value === '') return null;
  return value === true || value === 1 || value === '1';
};
const conditionChipClass = value =>
  value ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700';
const onusRequested = computed(() =>
  conditionFlag(props.request.onus_solicitada)
);
const onusLabel = computed(() =>
  onusRequested.value
    ? t('SALES.DETAIL.NUCLEO.YES')
    : t('SALES.DETAIL.NUCLEO.NO')
);
const districtSellers = computed(() =>
  props.request.vendedores_comarca
    ?.map(seller =>
      [seller.seller_name, seller.state].filter(Boolean).join(' - ')
    )
    .filter(Boolean)
    .join(', ')
);
const districtRequested = computed(() =>
  conditionFlag(props.request.vendedor_comarca)
);
const districtLabel = computed(() =>
  districtRequested.value
    ? t('SALES.DETAIL.NUCLEO.YES')
    : t('SALES.DETAIL.NUCLEO.NO')
);
</script>

<template>
  <section class="grid gap-4 sm:grid-cols-2">
    <dl
      v-if="onusRequested !== null"
      data-test="nucleo-onus-condition"
      class="rounded-lais border border-lais-border-soft bg-white p-4"
    >
      <dt
        class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
      >
        {{ t('SALES.DETAIL.NUCLEO.ONUS') }}
      </dt>
      <dd class="mt-2 flex flex-wrap items-center gap-2 text-sm">
        <span
          data-test="nucleo-onus-chip"
          class="rounded-full px-2.5 py-1 text-xs font-semibold"
          :class="conditionChipClass(onusRequested)"
        >
          {{ onusLabel }}
        </span>
        <span v-if="request.justificativa_onus" class="text-lais-text-body">
          {{ request.justificativa_onus }}
        </span>
      </dd>
    </dl>
    <dl
      v-if="districtRequested !== null"
      data-test="nucleo-other-district"
      class="rounded-lais border border-lais-border-soft bg-white p-4"
    >
      <dt
        class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
      >
        {{ t('SALES.DETAIL.NUCLEO.OTHER_DISTRICT') }}
      </dt>
      <dd class="mt-2 flex flex-wrap items-center gap-2 text-sm">
        <span
          data-test="nucleo-other-district-chip"
          class="rounded-full px-2.5 py-1 text-xs font-semibold"
          :class="conditionChipClass(districtRequested)"
        >
          {{ districtLabel }}
        </span>
        <span class="text-lais-text-body">
          {{ districtSellers || t('SALES.DETAIL.NUCLEO.DISTRICT_EMPTY') }}
        </span>
      </dd>
    </dl>
  </section>
</template>
